import Animate from './Animate';
import { configBezier, configSpring } from './easing';
import AnimateGroup from './AnimateGroup';
export { configSpring, configBezier, AnimateGroup };
export default Animate;


//////////////////
// WEBPACK FOOTER
// ./~/react-smooth/es6/index.js
// module id = ./node_modules/react-smooth/es6/index.js
// module chunks = 1